import { Page } from '@/core/architecture'

import { LotteryDeliveryInfoTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * LotteryDeliveryInfo Page
 * Implemented as a practical sample.
 */
export const LotteryDeliveryInfo: Page = () => {
  const { state, actions } = useViewModel()

  return <LotteryDeliveryInfoTemplate state={state} {...actions} />
}
